import { Dialog, Toast, ImagePreview } from "vant";

let CryptoJS = require("crypto-js");
let moment = require('moment');

function Utils () {
  // 登录加密keynpm in
  this.options = {
    key: "cuer6BeKHK0",          
    iv: "Xig6+j+mREs="
  }
}

Utils.prototype.moment = moment;

Utils.prototype.setCookie = function (token) {
  let Days = 30
  let exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  document.cookie = '.XYTOKEN' + '=' + encodeURIComponent(token) + ';expires=' + exp.toUTCString() + ';path=/'
}
Utils.prototype.getCookie = function (key) {
  let arr
  let token
  let reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
  arr = document.cookie.match(reg)
  if (arr) {
    token = decodeURIComponent(arr[2])
  } else {
    token = ''
  }
  return token
}
Utils.prototype.removeCookie = function (key) {
  let exp = new Date()
  exp = new Date(exp.setTime(exp.getTime() - 10 * 60000))
  let val = this.getCookie(key)
  if (val !== null) {
    document.cookie = key + '=' + encodeURIComponent(val) + ';expires=' + exp.toUTCString() + ';path=/'
  }
}

// 登录密码加密
Utils.prototype.encrypt = function (str) {
  var key = CryptoJS.enc.Base64.parse(this.options.key); //key 要和后台一致
  var iv = CryptoJS.enc.Base64.parse(this.options.iv);   //iv 要和后台一致
  str = CryptoJS.enc.Utf8.parse(str);
  return CryptoJS.DES.encrypt(str, key, { iv: iv, mode: CryptoJS.mode.CBC }).toString();
}

// 登录密码解密
Utils.prototype.decrypt = function (str) {
  var key = CryptoJS.enc.Base64.parse(this.options.key);
  var iv = CryptoJS.enc.Base64.parse(this.options.iv);
  var decryptObj = CryptoJS.DES.decrypt(str, key, { iv: iv, mode: CryptoJS.mode.CBC });
  return decryptObj.toString(CryptoJS.enc.Utf8);
}


Utils.prototype.loading = function (contents) {
  Toast.loading({
    duration: 0,
    forbidClick: true,
    // loadingType: 'spinner',
    message: contents ? contents : '加载中'
  })
}

Utils.prototype.unloading = function () {
  Toast.clear()
}

/* 成功提示 */
Utils.prototype.msgSuc = function (contents) {
  Toast.success({
    duration: 2000,
    forbidClick: true,
    message: contents
  })
}

/*失败提示*/
Utils.prototype.msgError = function (data) {
  Toast.fail({
    duration: 2000,
    forbidClick: true,
    message: data
  })
}


/* 提示 */
Utils.prototype.msgInfo = function (data) {
  Toast({
    duration: 3000,
    closeOnClick: true,
    // icon:'info',
    forbidClick: true,
    message: data
  })
}


/* 提示框 */
Utils.prototype.confirm = function (tite, msg, okFunc) {
  Dialog.confirm({
    title: tite,
    message: msg,
    getContainer() {
      return document.querySelector('#app');
    }
  }).then(() => {
    okFunc()
  }).catch(() => {
    // console.log('cancel')
  })
}

/*alert*/
Utils.prototype.alert = function (msg) {
  Dialog.alert({
    messageAlign:'left',
    message: msg,
    confirmButtonText: '我知道了'
  })
}

Utils.prototype.ImagePreview = ImagePreview

/*url解析*/
Utils.prototype.parseQueryString = function (val) {
  // let reg = /(([^?&=]+)(?:=([^?&=]*))*)/g;
  // let result = {};
  // let match;
  // let key;
  // let value;
  // // eslint-disable-next-line no-cond-assign
  // while (match = reg.exec(str)) {
  //   key = match[2];
  //   value = match[3] || '';
  //   result[key] = decodeURIComponent(value);
  // }
  // return result;
  let urlStr
  if (val) {
    urlStr = val
  } else {
    urlStr = location.search.substr(1) ? location.search.substr(1) : ''
  }
  let urlArr = []
  for (let i = 0; i < urlStr.split('&').length; i++) {
    urlArr.push(urlStr.split('&')[i].split('=')[0] ? urlStr.split('&')[i].split('=')[0] : '')
    urlArr.push(urlStr.split('&')[i].split('=')[1] ? urlStr.split('&')[i].split('=')[1] : 'onlyKey')
  }
  if (urlStr !== '') {
    var urlObj = {}
    for (var i = 0; i < urlArr.length; i += 2) {
      if (urlArr[i] !== '') {
        urlObj[urlArr[i]] = decodeURIComponent(urlArr[i + 1])
      }
    }
    return urlObj
  }
}

/* 下载文件 */
Utils.prototype.downFile = function (url, data, type) {
  data = data ? data : {}
  if (url.indexOf('?') > -1) {
    data = this.parseQueryString(url.slice(url.indexOf('?')))
  }
  type = type ? type : 'get'
  let formStr = `<form id='xyCommDownloadFileForm' style="visibility:hidden" method="${type}" action="${url}">`;
  for (let key in data) {
    formStr += `<input type='hidden' name="${key}" value="${data[key]}"/>`;
  }
  formStr += `<input type='hidden' name="XYTOKEN" value="${this.getCookie('.XYTOKEN')}" /></form>`;

  let bodyDom = document.querySelector('body');
  let formWrap = document.createElement('div');
  formWrap.id = 'formWrap';
  bodyDom.appendChild(formWrap)
  let formWrapNode = document.getElementById('formWrap');
  formWrapNode.innerHTML = formStr
  let formDom = document.getElementById("xyCommDownloadFileForm")
  formDom.submit();
  bodyDom.removeChild(formWrapNode)

}


Date.prototype.pattern = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, //小时
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  let week = {
    "0": "/u65e5",
    "1": "/u4e00",
    "2": "/u4e8c",
    "3": "/u4e09",
    "4": "/u56db",
    "5": "/u4e94",
    "6": "/u516d"
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[this.getDay() + ""]);
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
};

Utils.prototype.transferDate = function (date, fmt) {
  return new Date(date.replace('-', '/')).pattern(fmt)
};
Utils.prototype.getAMorPMCHN = function (type) {
  var str = "上午";
  switch (type) {
    case "MS":
      str = "早自习"
      break;
    case "AM":
      str = "上午";
      break;
    case "AB":
      str = "上午大课间";
      break;
    case "NS":
      str = "午休";
      break;
    case "PM":
      str = "下午";
      break;
    case "PB":
      str = "下午大课间";
      break;
    case "ES":
      str = "晚自习";
      break;
  }
  return str;
};
//name展示
Utils.prototype.showName = function (name) {
  // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
  if (!name) {
    return ''
  } else if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
    return name.length > 2 ? name.slice(-2) : name
  } else if (/^[A-Za-z]+$/g.test(name)) {
    // 纯英文名只展示两个字母
    return name.slice(0, 2)
  } else {
    // 其他
    return name.slice(0, 2)
  }
};
Utils.prototype.convertRangeNumber = function (num) {
  if (num < 0 || num > 19) {
    num = 0;
  }
  var listU = [
    "一", "二", "三", "四", "五", "六", "七", "八", "九", "十",
    "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十"
  ];
  return listU[num];
};
// 转换0-6的数字为星期的中文解释
// 从0开始
Utils.prototype.getChinesesWeekForNumSmall = function (num) {
  if (num < 0 || num > 6) {
    num = 0;
  }
  var listU = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
  return listU[num];
}
/*
    colors() 返回其中的某一个颜色
    如果index不传，将随机赋予一个0-20之间的随机数
*/
Utils.prototype.colors = function (index = parseInt(10 + Math.random() * 10)) {
  let colorList = [
    {
      bg: 'rgba(36, 123, 254,0.1)',
      color: '#247BFE',
    },
    {
      bg: 'rgba(144, 86, 255,0.1)',
      color: '#9056FF',
    },
    {
      bg: 'rgba(0, 114, 41,0.1)',
      color: '#007229',
    },
    {
      bg: 'rgba(207, 82, 0,0.1)',
      color: '#CF5200',
    },
    {
      bg: 'rgba(247, 181, 0,0.1)',
      color: '#F7B500',
    },
    {
      bg: 'rgba(161, 105, 254,0.1)',
      color: '#A169FE',
    },
    {
      bg: 'rgba(59, 134, 254,0.1)',
      color: '#3B86FE',
    },
    {
      bg: 'rgba(222, 97, 0,0.1)',
      color: '#DE6100',
    },
    {
      bg: 'rgba(0, 149, 48,0.1)',
      color: '#009530',
    },
    {
      bg: 'rgba(252, 201, 0,0.1)',
      color: '#FCC900',
    },
    {
      bg: 'rgba(175, 133, 254,0.1)',
      color: '#AF85FE',
    },
    {
      bg: 'rgba(91, 156, 251,0.1)',
      color: '#5B9CFB',
    },
    {
      bg: 'rgba(241, 124, 14,0.1)',
      color: '#F17C0E',
    },
    {
      bg: 'rgba(0, 171, 57,0.1)',
      color: '#00AB39',
    },
    {
      bg: 'rgba(251, 202, 76,0.1)',
      color: '#FBCA4C',
    },
    {
      bg: 'rgba(193, 162, 254,0.1)',
      color: '#C1A2FE',
    },
    {
      bg: 'rgba(107, 164, 254,0.1)',
      color: '#6BA4FE',
    },
    {
      bg: 'rgba(249, 150, 74,0.1)',
      color: '#F9964A',
    },
    {
      bg: 'rgba(106, 220, 162,0.1)',
      color: '#6ADCA2',
    },
    {
      bg: 'rgba(255, 220, 79,0.1)',
      color: '#FFDC4F',
    },
    {
      bg: 'rgba(199, 172, 255,0.1)',
      color: '#C7ACFF',
    },
    {
      bg: 'rgba(120, 173, 253,0.1)',
      color: '#78ADFD',
    },
    {
      bg: 'rgba(253, 177, 121,0.1)',
      color: '#FDB179',
    },
    {
      bg: 'rgba(135, 224, 176,0.1)',
      color: '#87E0B0',
    },
    {
      bg: 'rgba(255, 229, 126,0.1)',
      color: '#FFE57E',
    },
    {
      bg: 'rgba(226, 205, 255,0.1)',
      color: '#E2CDFF',
    },
    {
      bg: 'rgba(138, 184, 255,0.1)',
      color: '#8AB8FF',
    },
    {
      bg: 'rgba(251, 195, 153,0.1)',
      color: '#FBC399',
    },
    {
      bg: 'rgba(167, 230, 196,0.1)',
      color: '#A7E6C4',
    }
  ]

  if (index < 20) {
    return colorList[index];
  } else {
    //颜色色值是20个
    let value = 20;
    let tIndex = index % value;

    return colorList[tIndex];
  }
}

let xyUtils = new Utils()
export default xyUtils
